<template>
  <el-dialog
    :visible="visible"
    width="40%"
    @close="cancel"
    destroy-on-close
    :title="openType === 'add' ? '新增管理员' : '编辑管理员'"
    custom-class="customModal">
    <AppForm
      v-if="visible"
      ref="form"
      formStyle="default"
      :fields="formFields"
      :rules="rules"
      :defaultValues="defaultValues"
      @cancel="cancel"
      @submit="submit"
      />
  </el-dialog>
</template>

<script>
import { ManagerService } from '../../service/manager.service';
  export default {
    name: 'managerForm',
    props: {
      roleList: {
        type: Array,
        default: () => [],
      }
    },
    data() {
      return {
        visible: false,
        openType: '',
        rules: {
          username: [{ required: true, message: '请填写管理员姓名'}],
          pwd: [{ required: true, message: '请填写密码'}],
          role_id: [{ required: true, message: '请选择管理员角色'}],
        },
        formFields: [
          { type: 'input', key: 'username', label: '管理员姓名', span: 24 },
          { type: 'password', key: 'pwd', label: '密码', span: 24 },
          { type: 'input', key: 'mobile', label: '手机号', span: 24 },
          { type: 'select', key: 'role_id', label: '管理员', span: 24, options: [] },

        ],
        defaultValues: {
        },
      }
    },
    methods: {
      open(type, data) {
        this.formFields[3].options = this.roleList;
        this.openType = type;
        if(type === 'edit') {
          this.defaultValues = Object.assign({}, data);
        } else {
          this.defaultValues = {};
        }
        this.visible = true;
      },
      cancel() {
        this.visible = false;
      },
      async submit(data) {
        await ManagerService.saveManager(data);
        this.cancel();
        this.$emit('success');
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>